import { render, staticRenderFns } from "./CWarningModal.vue?vue&type=template&id=673086e9&"
import script from "./CWarningModal.vue?vue&type=script&lang=js&"
export * from "./CWarningModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports